import { push } from 'redux-first-history';
import { all, takeEvery, call, put } from 'redux-saga/effects';
import ApiInstance from 'src/helpers/apiInstance';
import actions from './actions';
import agenciesActions from '../actions';
import { sendRequest } from '../../../../../../helpers/saga';
import notifications from '../../../../../../redux/notifications/actions';
import { logger } from '../../../../../../helpers/logger';

const updateAgenciesApi = new ApiInstance('units/:id/agencies/mark_as_required');

function* updateAgencies({ payload }) {
  const { id, agencyIds } = payload;

  try {
    const result = yield call(
      sendRequest,
      updateAgenciesApi.put,
      { pathParams: { id }, data: { agency_ids: agencyIds } },
      notifications.REQUEST_ERROR,
    );

    if (result?.status === 200) {
      yield put(agenciesActions.loadAgenciesRequest({ id }));
      yield put(actions.updateAgenciesSuccess());
      yield yield put(push(`/units/${id}?tab[]=agencies`));
    } else {
      yield put(actions.updateAgenciesError());
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.UPDATE_AGENCIES_REQUEST, updateAgencies)]);
}
